import { IOnInit, IPromise } from "angular";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../../../records/forms/formView";
import fieldHelpers from "../../../../../../ui-formly/fieldHelpers";
import { StateService } from "@uirouter/angularjs";
import { RecordFileTemplateOptions } from "../../../../../../records/forms/formly/types";
import { MachineThreeRivers } from "../../../../models/machine";
import { IFieldArray } from "AngularFormly";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../../records/forms/formly/fieldConfigurationHelpers";
import * as lookupNames from "../../../../configs/lookup";
import { LookupManagementService } from "../../../../../../records/lookup/lookupManagement";
import { vsLookupManagementServiceName } from "../../../../../shared/lookups";

export class SingleMachineMoveComponentController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
    vsLookupManagementServiceName,
  ];
  readonly formFields: IFieldArray;
  model: any;
  /* start bindings */
  readonly machine!: MachineThreeRivers;
  /* end binding */

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    fieldConfigurationHelperService: FieldConfigurationHelperService,
    private readonly lookupManagementService: LookupManagementService
  ) {
    const fileTemplateOptions: RecordFileTemplateOptions = {
      allowMultiple: true,
      label: "Files",
    };
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleDateField({
            key: "Date",
            name: "Date",
            label: "Change Date",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "SlotNumber",
            name: "SlotNumber",
            label: "Asset Number",
            required: true,
          }),
        ],
        4
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldConfigurationHelperService.selectAsyncField({
            queryUrl: "/api/properties",
            getDefaultItem: (model: any) => model.Property,
            label: "Property",
            key: "PropertyId",
            required: true,
          }),
          fieldConfigurationHelperService.lookupField(
            this.lookupManagementService,
            {
              key: "MachineAreaId",
              label: "Area",
              required: true,
              objectName: lookupNames.areaName,
            }
          ),
          fieldHelpers.simpleStringField({
            key: "Section",
            name: "Section",
            label: "Section",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "Bank",
            name: "Bank",
            label: "Bank",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "Position",
            name: "Position",
            label: "Position",
            required: true,
          }),
          fieldConfigurationHelperService.lookupField(
            this.lookupManagementService,
            {
              key: "MachineBankConfigId",
              label: "Bank Config",
              required: true,
              objectName: lookupNames.machineBankConfigName,
            }
          ),
        ],
        4
      ),
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: fileTemplateOptions,
      },
      fieldHelpers.headerField({
        headerText: "Notes",
        key: "NotesHeader",
      }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    const currentConfiguration = this.machine.Configs?.find(
      (c) => c.CurrentConfiguration
    );
    this.model = {
      MachineId: this.machine.Id,
      Files: currentConfiguration?.Files?.map((f: any) => {
        return { Name: f.Name, ContentType: f.ContentType, Url: f.Url };
      }),
    };
  }

  submit(formViewController: FormViewController): IPromise<void> {
    const machineId = this.machine.Id;
    return this.formViewService
      .submitForm({
        url: `/api/machines/${machineId}/move`,
        formObject: this.model,
        formViewController,
        method: "post",
      })
      .then(() => {
        return this.$state.go("^", undefined, { reload: true });
      })
      .then(() => {});
  }

  cancel(): Promise<void> {
    return this.$state.go("^").then(() => {});
  }
}
